import React from 'react'
import { ExpandableSection } from '@enterprise-ui/canvas-ui-react'
import { COST_CHANGE_INSIGHTS_ITEM_RESULTS } from '../../globalConfig/constants'
import { SubmissionRecordsTable } from './SubmissionRecordsTable'

export const CollapsibleItemGrouping = React.memo(
  ({
    itemDetails,
    isExpanded,
    onExpand,
    page,
    recordsPerPage,
    updatePage,
    updateRecordsPerPage,
    submissionRecords,
  }) => {
    const primaryFields = {
      DPCI: COST_CHANGE_INSIGHTS_ITEM_RESULTS.DPCI,
      TCIN: COST_CHANGE_INSIGHTS_ITEM_RESULTS.TCIN,
      ITEM_NAME: COST_CHANGE_INSIGHTS_ITEM_RESULTS.ITEM_NAME,
    }
    const secondaryFields = {
      UPCS: COST_CHANGE_INSIGHTS_ITEM_RESULTS.UPCS,
      DEPARTMENT_ID: COST_CHANGE_INSIGHTS_ITEM_RESULTS.DEPARTMENT_ID,
      CLASS_ID: COST_CHANGE_INSIGHTS_ITEM_RESULTS.CLASS_ID,
      BRANDS: COST_CHANGE_INSIGHTS_ITEM_RESULTS.BRANDS,
      STYLE_ID: COST_CHANGE_INSIGHTS_ITEM_RESULTS.STYLE_ID,
      SECONDARY_UPCS: COST_CHANGE_INSIGHTS_ITEM_RESULTS.SECONDARY_UPCS,
    }

    const getSecondaryFieldValueText = (field, value) => {
      if (field?.tableDetails?.toStringFunc) {
        return field.tableDetails.toStringFunc(value)
      } else {
        return value
      }
    }

    return (
      <>
        <ExpandableSection
          className="hesp-general-expandable"
          padding="none"
          preserveDom
          onExpand={() =>
            onExpand(
              itemDetails[COST_CHANGE_INSIGHTS_ITEM_RESULTS.TCIN.variableName],
            )
          }
          expanded={isExpanded}
        >
          <div>
            <div className="hc-fs-lg hesp-general-flex">
              {Object.values(primaryFields).map((primaryField) => {
                return (
                  <span
                    className="hesp-general-flex-grow hesp-general-centeredText hesp-general-fullwidth"
                    key={`${primaryField.variableName}-item-group-header`}
                  >
                    {itemDetails[primaryField.variableName]}
                  </span>
                )
              })}
            </div>
            <div className="hc-mt-xs">
              {Object.values(secondaryFields).map((secondaryField) => {
                if (
                  itemDetails[secondaryField.variableName]?.length ||
                  typeof itemDetails[secondaryField.variableName] === 'number'
                ) {
                  return (
                    <span
                      className="hc-mr-lg hc-fs-sm"
                      key={`${secondaryField.variableName}-item-group-subheader`}
                    >
                      {`${secondaryField.label}: ${getSecondaryFieldValueText(secondaryField, itemDetails[secondaryField.variableName])}`}
                    </span>
                  )
                } else {
                  return null
                }
              })}
            </div>
          </div>
          <ExpandableSection.Content>
            <SubmissionRecordsTable
              submissionRecords={submissionRecords}
              page={page}
              recordsPerPage={recordsPerPage}
              updatePage={updatePage}
              updateRecordsPerPage={updateRecordsPerPage}
              tcin={
                itemDetails[COST_CHANGE_INSIGHTS_ITEM_RESULTS.TCIN.variableName]
              }
            />
          </ExpandableSection.Content>
        </ExpandableSection>
      </>
    )
  },
)
